import DashboardMixin from '@/mixins/dashboard';

export default {
  mixins: [DashboardMixin],

  computed: {
    navigationItems() {
      const ni = this.$store.getters['navigationItems/menuItems'];
      return ni.filter(ni => !ni.dynamic && this.canAccessDashboardResource(ni));
    },
  },

  methods: {
    navItemActive(navItem) {
      if (this.activeItem) {
        return this.activeItem.id === navItem.id;
      }
      return this.active.id === navItem.id;
    },
    navItemClicked(navItem, closeFunction = null) {
      const navGroup = this.$store.getters['navigationGroups/navigationGroups'][navItem.navigationGroupId];
      this.$analytics.events.selectedNavItem(navItem, navGroup, null);
      if (closeFunction) {
        closeFunction();
      }
    },
    navItemIcon(navItem) {
      return this.navItemActive(navItem) ? navItem.activeIcon : navItem.icon;
    },
  },
};
